export default "__VITE_ASSET__BdwvXQzn__"